import React from 'react';
import { bool, func, shape, arrayOf, number } from 'prop-types';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';

import CourseList from 'Jsx/Catalog/containers/CourseList';

import {
  COURSES_PAGE_SIZE,
  formatCourseV2,
  checkIfisInShoppingCart,
} from 'Jsx/Catalog/utils';

import getCoursesRecommended from 'Jsx/Catalog/graphql/searchCourses.graphql';

const CourseRecommended = ({
  courseIdsOwned,
  removeCourseFromCart,
  addCourseToCart,
  // redux
  loading,
  user,
  courses,
  itemsPerRow,
  isOrganization,
}) => (
  <CourseList
    skeletonItems={24}
    courses={courses}
    loading={loading}
    isUserLogged={!!user}
    user={user}
    courseIdsOwned={courseIdsOwned}
    removeCourseFromCart={removeCourseFromCart}
    addCourseToCart={addCourseToCart}
    itemsPerRow={itemsPerRow}
    isOrganization={isOrganization}
  />
);

CourseRecommended.defaultProps = {
  user: null,
  isOrganization: false,
};

CourseRecommended.propTypes = {
  removeCourseFromCart: func.isRequired,
  addCourseToCart: func.isRequired,
  courseIdsOwned: arrayOf(number).isRequired,
  // redux
  loading: bool.isRequired,
  user: shape({
    originalId: number.isRequired,
  }),
  courses: arrayOf(
    shape({
      originalId: number.isRequired,
    }),
  ).isRequired,
  itemsPerRow: shape({
    1680: number,
    1440: number,
    1280: number,
    1024: number,
    768: number,
  }),
  isOrganization: bool,
};

CourseRecommended.defaultProps = {
  itemsPerRow: {
    1680: 4,
    1440: 3,
    1280: 3,
    1024: 3,
    768: 3,
  },
};

const mapStateToProps = ({ user }) => ({ user });

export default compose(
  connect(mapStateToProps),
  graphql(getCoursesRecommended, {
    name: 'courses',
    options: {
      variables: {
        pageSize: COURSES_PAGE_SIZE,
        listRecommended: 'no-results',
        newOrderBy: 'paid',
      },
    },
    props: ({
      ownProps: { courseIdsOwned },
      courses: { loading, searchCourses, error },
    }) => ({
      loading,
      error,
      courses: searchCourses
        ? searchCourses.edges
            .map(c => c.node)
            .map(formatCourseV2)
            .map(checkIfisInShoppingCart(courseIdsOwned))
        : [],
    }),
  }),
)(CourseRecommended);
